import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-available-products',
  templateUrl: './available-products.component.html',
  styleUrls: ['./available-products.component.scss']
})
export class AvailableProductsComponent implements OnInit {
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  AvailableProducts: any[];
  selectedProducts: any[];
  mappedProducts: any[] = [];
  screenheading :any= "";


  constructor(
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    public commonService: CommonService
  ) { }

  ngOnInit() {
     
    switch (this.content.TargetScreen) {
      case "theraupeticArea":
        this.screenheading = "Available Products";
        this.getTheraupetiProducts();
        break;
      case "program":
        this.selectedProducts = [];
        this.screenheading = "Available Products";
        this.getProgramProducts();
        break;
      case "NetworkLocations":
        this.screenheading = "Available Network Locations";
        this.getNetworkLocations();
        break;
    }
  }
  checkSelected(){
    this.AvailableProducts.forEach((item:any) => {
      if(this.selectedProducts.indexOf(item.value) != -1) {
        item.isSelected = true;
      }
      else {
        item.isSelected = false;
      }
  })
  }

  getSavedappings() {
     
    this.summaryService.getRecord('api/AdminProgram/getSavedMappings?RecordID=' + this.content.id).subscribe(summary => {
       ;
      this.selectedProducts = summary as [];
      this.checkSelected();
    });
  }
  SaveMapping() {
      ;
    var selectedValues = "";
    if (this.selectedProducts != undefined && this.selectedProducts.length > 0) {
       ;
      this.selectedProducts.forEach(obj => {
        
        var Mapobj = this.AvailableProducts.filter(function (element) 
        {
          return element.value ==obj;
        })[0];
        if (Mapobj != null && Mapobj != undefined) {
          this.mappedProducts.push(Mapobj);
        }
          
      });
       ;
      var data = new FormData();
      data["TransactionID"] = this.content.id;
      data["clsificationType"] = selectedValues;
      this.modalRef.close(this.mappedProducts);
    }
    else {
      this.commonService.ValidationBanner('Please select Atleast One Product.');
    }
  }
  CollectItem(item) {
    if (this.selectedProducts.indexOf(item) == -1) {
      this.selectedProducts.push(item);
    }
    else {
      this.selectedProducts.splice(this.selectedProducts.indexOf(item),1);
    }
  }
  getTheraupetiProducts()
  {
    this.summaryService.getRecord('../api/Theraupetic_Area/GetAvailableProducts?RecordID=' + this.content.id).subscribe(summary => {
       this.AvailableProducts = summary as [];
    });
  }
  getProgramProducts() {
    this.summaryService.getRecord('api/AdminProgram/GetProductsAvaliable').subscribe(summary => {
      
      this.AvailableProducts = summary as [];
      if (this.content.flag == "E"){this.getSavedappings();}
    });
  }
  getNetworkLocations() {
  
  }
}
